import { render, staticRenderFns } from "./spu.component.vue?vue&type=template&id=70940b87&scoped=true&"
import script from "./spu.component.vue?vue&type=script&lang=ts&"
export * from "./spu.component.vue?vue&type=script&lang=ts&"
import style0 from "./spu.component.vue?vue&type=style&index=0&id=70940b87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70940b87",
  null
  
)

export default component.exports